"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const react_number_format_1 = __importDefault(require("react-number-format"));
const server_1 = require("react-dom/server");
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
const recharts_1 = require("recharts");
const styled_1 = require("./styled");
const currencyPrefixes = {
    USD: '$',
    AUD: '$',
    HKD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    CNY: '¥',
    BTC: '฿',
    BCH: '฿'
};
const formattedPrice = (val, curr) => {
    const num = (react_1.default.createElement(react_number_format_1.default, { value: val, decimalScale: 2, displayType: "text", prefix: currencyPrefixes[curr], thousandSeparator: true, renderText: (value) => value }));
    return (0, server_1.renderToString)(num);
};
const getPaddedDomain = (data) => {
    const prices = data.map((dataPoint) => dataPoint.open);
    const max = Math.max(...prices);
    const min = Math.min(...prices);
    const cushion = (max - min) * .15;
    return [(min - cushion) > 0 ? (min - cushion) : 0, max + cushion];
};
const getMaxCoords = (data) => {
    const max = data.reduce((prev, current) => (prev.open > current.open) ? prev : current);
    return max;
};
const getMinCoords = (data) => {
    const min = data.reduce((prev, current) => (prev.open < current.open) ? prev : current);
    return min;
};
/**
 * Price Chart component
 *
 * Price Chart for historical coin data `recharts` http://recharts.org/en-US/api/PieChart
 *
 */
const PriceChart = (_a) => {
    var { timeFormat = "ddd Do HH:MM", data = [], dataKey = "open", currency = "USD", width = 64, angle = 0, xInterval = "preserveEnd", minTickGap = 70 } = _a, rest = __rest(_a, ["timeFormat", "data", "dataKey", "currency", "width", "angle", "xInterval", "minTickGap"]);
    const axisStyle = {
        fill: "#131720",
        fontSize: "10px",
        fontWeight: "bold",
        fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        textAnchor: "end",
    };
    const yAxisStyle = { angle };
    const maxPoint = getMaxCoords(data);
    const minPoint = getMinCoords(data);
    return (react_1.default.createElement(styled_1.Wrapper, Object.assign({}, rest),
        react_1.default.createElement(styled_1.ChartWrapper, null,
            react_1.default.createElement(recharts_1.ResponsiveContainer, { debounce: 1 },
                react_1.default.createElement(recharts_1.AreaChart, { data: data, margin: { top: 10, left: 24, bottom: 10 } },
                    react_1.default.createElement(recharts_1.YAxis, { domain: getPaddedDomain(data), scale: "linear", tick: axisStyle, tickFormatter: val => {
                            return formattedPrice(val, currency);
                        }, tickCount: 6, interval: "preserveEnd", width: width }),
                    react_1.default.createElement(recharts_1.XAxis, { dataKey: "time", tick: Object.assign(Object.assign({}, axisStyle), yAxisStyle), minTickGap: minTickGap, interval: xInterval, tickFormatter: (tick) => {
                            return moment_1.default.unix(tick).format(timeFormat);
                        }, 
                        /* tickMargin={16} */
                        tickSize: 0 }),
                    react_1.default.createElement(recharts_1.CartesianGrid, { stroke: "rgba(180, 180, 180, 0.4)", vertical: false }),
                    react_1.default.createElement(recharts_1.Tooltip
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    , { 
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        content: (res = {}) => {
                            const payload = res.payload && res.payload.length > 0 && res.payload[0]
                                ? res.payload[0].payload
                                : { [dataKey]: "", time: 0 };
                            const price = react_1.default.createElement("span", null, formattedPrice(payload[dataKey], currency));
                            const time = moment_1.default.unix(payload.time).format(timeFormat);
                            return (react_1.default.createElement("div", null,
                                react_1.default.createElement(styled_1.Label, null,
                                    react_1.default.createElement("p", null, `${time}:`),
                                    react_1.default.createElement("p", { className: "price-label" }, price))));
                        } }),
                    react_1.default.createElement(recharts_1.Area, { type: "monotone", dataKey: dataKey, activeDot: {
                            fill: "#FFFFFF",
                            stroke: "#6B717E",
                            strokeWidth: 3,
                            r: 6,
                        }, fillOpacity: 0.2, fill: "#0AC18E", stroke: "#0AC18E", strokeWidth: 2 }),
                    react_1.default.createElement(recharts_1.ReferenceLine, { y: maxPoint.open, stroke: bitcoincom_pkg_theme_1.colors.solid.caribbeanGreen, strokeDasharray: "3 3", strokeWidth: 2 }),
                    react_1.default.createElement(recharts_1.ReferenceLine, { y: minPoint.open, stroke: bitcoincom_pkg_theme_1.colors.solid.cinnabar, strokeDasharray: "3 3", strokeWidth: 2 }))))));
};
exports.default = PriceChart;
//# sourceMappingURL=PriceChart.js.map